import NoticeIcon from 'assets/icons/notice-yellow-icon.svg';
import AlertPopup from 'components/common/PortalModal/popups/AlertPopup';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import usePortalModal from 'hooks/usePortalModal';
import { functionUtils } from 'utils';

const CreateReceiverModal = ({ isShow, title, content, action }) => {
  const { t } = useLang();
  const { closePortalModalName } = usePortalModal();
  const { isDesktop } = useDetectDevice();

  const handleOnClick = () => {
    if (functionUtils.isFunction(action)) {
      action();
    }
    closePortalModalName();
  };

  return (
    <AlertPopup
      isOpen={isShow}
      imageSrc={NoticeIcon}
      imagesStyles={{
        width: '75px',
        height: '60px',
      }}
      text={title || ''}
      content={content || ''}
      buttonLabel2={t('button_ok')}
      onClick={handleOnClick}
      isBackdropOverlap={true}
      zIndexBackdropOverlap={1055}
    />
  );
};

export default CreateReceiverModal;
